import { useTranslations } from '@lang';

export function useCouldNotCheckFeedback(
  isCheckFailed: boolean,
  retry: () => void,
  isRetrying = false
) {
  const { t } = useTranslations();

  if (!isCheckFailed) return undefined;

  return {
    title: t('spa.package.integrationUnavailableHeading'),
    description: t('common.couldNotCheckDescription'),
    actionLabel: t('common.tryAgain'),
    onAction: retry,
    isActionPending: isRetrying,
  };
}
